import React from 'react';

import Icon1 from '../../../assets/images/info/icon1.png';
import Icon2 from '../../../assets/images/info/icon2.png';
import Icon3 from '../../../assets/images/info/icon3.png';
import useTranslation from '../../../utils/hooks/useTranslation';

export default function InfoSection() {
    const { t } = useTranslation();

    const cards = [
        { icon: Icon1, title: t('message.info_new_tech_title'), desc: t('message.info_new_tech_desc') },
        { icon: Icon2, title: t('message.info_top_deals_title'), desc: t('message.info_top_deals_desc') },
        { icon: Icon3, title: t('message.info_support_title'), desc: t('message.info_support_desc') }
    ];

    return (
        <section className="info-section-modern">
            {cards.map((card, i) => (
                <div className="info-card" key={`info-card-${i}`}>
                    <div className="info-card-icon">
                        <img src={card.icon} alt="" />
                    </div>
                    <div className="info-card-body">
                        <h4>{card.title}</h4>
                        <p>{card.desc}</p>
                    </div>
                </div>
            ))}
        </section>
    );
}
